import React from 'react';
import { SPAN_KPI, SPAN_CHART, SPAN_ATTENTION, SPAN_LEADS } from './gridSpans';
import Placeholder from '../../../ui/atoms/Placeholder';
import SessionsKpiWidget from './SessionsKpiWidget';
import MessagesKpiWidget from './MessagesKpiWidget';
import ResolveRateKpiWidget from './ResolveRateKpiWidget';
import LeadsKpiWidget from './LeadsKpiWidget';
import ActivityChartWidget from './ActivityChartWidget';
import AttentionWidget from './AttentionWidget';
import RecentLeadsWidget from './RecentLeadsWidget';

const AgentDashboardGrid = ({
  loading,
  stats,
  primaryAgentId,
  onNavigate
}) => {
  if (loading) {
    return (
      <div className="space-y-5">
        <div className="grid grid-cols-12 gap-3">
          <div className={SPAN_KPI}><Placeholder size="s" /></div>
          <div className={SPAN_KPI}><Placeholder size="s" /></div>
          <div className={SPAN_KPI}><Placeholder size="s" /></div>
          <div className={SPAN_KPI}><Placeholder size="s" /></div>
        </div>
        <div className="grid grid-cols-12 gap-5">
          <div className={SPAN_CHART}><Placeholder size="l" /></div>
        </div>
        <div className="grid grid-cols-12 gap-5">
          <div className={SPAN_LEADS}><Placeholder size="m" /></div>
          <div className={SPAN_ATTENTION}><Placeholder size="m" /></div>
        </div>
      </div>
    );
  }

  if (!stats) {
    return null;
  }

  const statsOverviewHref = primaryAgentId
    ? `/agent/ai-agents/${primaryAgentId}?tab=overview`
    : '/agent/ai-agents';

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-12 gap-3">
        <div className={SPAN_KPI}>
          <SessionsKpiWidget totalSessions={stats.totalSessions} />
        </div>
        <div className={SPAN_KPI}>
          <MessagesKpiWidget totalMessages={stats.totalMessages} />
        </div>
        <div className={SPAN_KPI}>
          <ResolveRateKpiWidget
            resolveRate={stats.resolveRate}
            resolvedCount={stats.resolvedCount}
            sessionsWithStatus={stats.sessionsWithStatus}
          />
        </div>
        <div className={SPAN_KPI}>
          <LeadsKpiWidget totalLeads={stats.totalLeads} />
        </div>
      </div>

      <div className="grid grid-cols-12 gap-5">
        <div className={SPAN_CHART}>
          <ActivityChartWidget
            chartData={stats.chartData}
            statsOverviewHref={statsOverviewHref}
            onNavigate={onNavigate}
          />
        </div>
      </div>

      <div className="grid grid-cols-12 gap-5">
        <div className={SPAN_LEADS}>
          <RecentLeadsWidget
            recentLeads={stats.recentLeads}
            totalLeads={stats.totalLeads}
            onNavigate={onNavigate}
          />
        </div>
        <div className={SPAN_ATTENTION}>
          <AttentionWidget
            attentionSessions={stats.attentionSessions}
            actionRequiredCount={stats.actionRequiredCount}
            onNavigate={onNavigate}
          />
        </div>
      </div>
    </div>
  );
};

export default AgentDashboardGrid;
